// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ITH","type":"styles_type__rM2-Z","choices":"styles_choices__ecjjt"};